/* eslint-disable complexity */
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import ProductDeal from "../../../ProductDeal";
import ProductSponsored from "../../../ProductSponsored";
import SellingFastBadge from "../../../SellingFastBadge";
import styles from "./index.css";
import originalStyles from "../../../index.css";
import classnames from "classnames";
import ProductBadge from "../../../ProductBadge";
import {
  MIX_MATCH,
  MORE_COLOURS,
  MORE_COLOURS_FACET
} from "../../../../../state/modules/search/constants";
import { getCategoryTreatments } from "../../../../../state/modules/category";
import { getViewportCategory } from "../../../../../state/modules/layout/selectors";
import { LARGE_VIEWPORT } from "../../../../../state/modules/layout/constants";

const Banners = ({
  deal,
  dealAria,
  isSponsored,
  isSellingFast,
  sellingFastStyle,
  ariaLabels,
  badgeType
}) => {
  const treatments = useSelector(getCategoryTreatments);
  const viewportCategory = useSelector(getViewportCategory);
  const newStyles =
    treatments && viewportCategory !== LARGE_VIEWPORT ? originalStyles : styles;

  return (
    <>
      {deal !== null && (
        <ProductDeal
          deal={deal}
          dealAria={dealAria}
          className={newStyles.topLeftBadge}
          labelledById={ariaLabels.deal}
        />
      )}
      {isSponsored && (
        <ProductSponsored
          className={newStyles.topRightBadge}
          labelledById={ariaLabels.sponsored}
        />
      )}
      {isSellingFast && (
        <SellingFastBadge
          className={classnames(newStyles.sellingFastBadge, sellingFastStyle)}
          labelledById={ariaLabels.sellingFast}
        />
      )}
      {badgeType && (
        <ProductBadge
          className={newStyles.bottomLeftBadge}
          type={badgeType}
          labelledById={ariaLabels.productBadge}
        />
      )}
    </>
  );
};

Banners.propTypes = {
  deal: PropTypes.string,
  dealAria: PropTypes.string,
  isSponsored: PropTypes.bool.isRequired,
  isSellingFast: PropTypes.bool.isRequired,
  sellingFastStyle: PropTypes.string,
  ariaLabels: PropTypes.shape({
    deal: PropTypes.string,
    sponsored: PropTypes.string,
    sellingFast: PropTypes.string,
    productBadge: PropTypes.string
  }),
  badgeType: PropTypes.oneOf([MIX_MATCH, MORE_COLOURS, MORE_COLOURS_FACET])
};

export default Banners;
